// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 632 ? "bec4887d" : chunkId) + "." + {"397":"c3568d6be4889ddf","632":"cd6482c13c77e882"}[chunkId] + ".js";
};